export const formatMilliseconds = (ms: number, padding = 2) => {
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / 1000 / 60) % 60);
  const hours = Math.floor(ms / 1000 / 3600);

  const result = [
    hours >= 1 ? `${hours}`.padStart(hours <= 0 ? padding : 1, '0') : '',
    `${minutes}`.padStart(padding, '0'),
    `${seconds}`.padStart(2, '0'),
  ].filter(Boolean); // removes empty values

  return result.join(':');
};

export const getApiErrorMessage = (messages: string[]) => messages.join(', ');

export const capitalizationText = (text: string, trim = false) => {
  const newWord = text.replace(
    /\w\S*/g,
    (l) => l.charAt(0).toUpperCase() + l.substr(1).toLowerCase()
  );

  return trim ? newWord.trim() : newWord;
};

export const parseFullName = (input: string) => {
  const fullName = input || '';
  const result = {
    name: '',
    lastName: '',
    secondLastName: '',
  };

  if (fullName.length === 0) {
    return result;
  }

  const nameTokens =
    fullName.match(
      /[A-ZÁ-ÚÑÜa-zá-úñü]+|([aeodlsz]+\s+)+[A-ZÁ-ÚÑÜa-zá-úñü]+/g
    ) || [];

  if (nameTokens.length > 3) {
    result.name = nameTokens.slice(0, 2).join(' ');
  } else {
    result.name = nameTokens.slice(0, 1).join(' ');
  }

  if (nameTokens.length > 2) {
    result.lastName = nameTokens.slice(-2, -1).join(' ');
    result.secondLastName = nameTokens.slice(-1).join(' ');
  } else if (nameTokens.length > 1) {
    result.lastName = nameTokens.slice(-1).join(' ');
  }

  return result;
};
